import { Injectable } from '@angular/core';
import { SessionCookies } from '@enums';
import { toTrackedPath } from '@utils';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private cookieService: CookieService) {
    if (environment.gaMeasurementId) {
      this.loadGoogleAnalytics(environment.gaMeasurementId);
    }
  }

  // `send_page_view: false`: page views are sent by AppComponent on every
  // navigation. The automatic one would carry the full `page_location`,
  // reset token included, on the first load of a reset link.
  private loadGoogleAnalytics(measurementId: string) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', { send_page_view: false });
    `;
    document.head.appendChild(inlineScript);
  }

  // Every event carries an explicit `page_location`; gtag would otherwise
  // fill it from `document.location`, query string included.
  public trackEvent(
    eventName: string,
    eventParams: Record<string, string | number> = {},
  ) {
    if (!environment.gaMeasurementId) return;

    const userName = this.cookieService.get(SessionCookies.userName);
    if (userName && eventName !== 'page_view' && eventName !== 'time_spent') {
      eventParams['user'] = userName;
    }
    const { origin, pathname, search, hash } = window.location;
    const params = {
      page_location: `${origin}${toTrackedPath(pathname + search + hash)}`,
      ...eventParams,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).gtag('event', eventName, params);
  }
}
